import { TaxInfoFormCard } from '@/components/TaxInfoFormCard'
import { getMyTaxInfoApi, updateMyTaxInfoApi } from '@/lib/api'

/**
 * Self-service tax information card (DESIGN_TaxFilingProvision.md §3.3).
 * Shows the masked tax profile of the logged-in user and lets them enter or
 * correct their own tax residency + identifiers (the compliance path remains
 * employer-managed entry; this is the self-service convenience edit).
 * Shared implementation: TaxInfoFormCard.
 */
export function TaxInfoCard() {
  return <TaxInfoFormCard fetchTaxInfo={getMyTaxInfoApi} saveTaxInfo={updateMyTaxInfoApi} />
}
